<template>
  <Questionnaire @submitted="onSubmit" />
  <DoneModal
    :open-dialog="openDoneModal"
    :text="`All done! Thank you for helping ${senderCompaniesText} with mapping their supply chain.`"
    @close-dialog="$router.push(RouterPath.Home)"
  />
</template>

<script setup lang="ts">
import Questionnaire from "@/components/questionnaire/Questionnaire.vue";
import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";
import { RouterPath } from "@/models/enum/routerPath";
import DoneModal from "@/components/questionnaire/DoneModal.vue";
import { useSelectedQuestionnaire } from "@/stores/selectedQuestionnare";
import { ForwardingStatus } from "@/models/enum/forwardingStatus";

const router = useRouter();
const selectedQuestionnaireStore = useSelectedQuestionnaire();

const openDoneModal = ref(false);
const senderCompaniesText = ref("");

function getSenderCompanies() {
  const allSenderCompanies = selectedQuestionnaireStore.questionnaires.map(
    (s) => s.senderCompanies
  );
  const uniqueSenderCompanies = [...new Set(allSenderCompanies.flat())];
  senderCompaniesText.value = getConcatenatedSenderCompanies(
    uniqueSenderCompanies
  );
}

onBeforeMount(() => {
  selectedQuestionnaireStore.progress = 1;
  getSenderCompanies();
});

async function onSubmit() {
  if (
    selectedQuestionnaireStore.questionnaires.every((x) => {
      return (
        x.isBusinessPartner ||
        x.forwardingStatus === ForwardingStatus.Completed ||
        x.forwardingStatus === ForwardingStatus.NotApplicable
      );
    })
  ) {
    openDoneModal.value = true;
  } else {
    await router.push(RouterPath.UploadSuppliersForQuestionnaire);
  }
}

function getConcatenatedSenderCompanies(senders: string[]) {
  //Replace the last , with 'and '
  //"PwC Norway, NRK, TV2 and RiksTV"
  return senders.join(", ").replace(/,(?=[^,]*$)/, " and");
}
</script>
